/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）)
 * @export
 * @enum {number}
 */
export enum FareTypeEnum {
    /** メーター運賃 */
    METER_FARE = '1',
    /** 事前確定 */
    FIXED_FARE = '2',
    /** 事前確定運賃（RS含む） */
    FIXED_FARE_RS = '3'
}

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）) の Union 型
 * @export
 * @typedef FareType
 */
export type FareType =
  typeof FareTypeEnum[keyof typeof FareTypeEnum];

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）) のラベルマップ
 * @export
 */
export const FareTypeLabels = {
    /**
     * 数値キー: FareTypeEnum.METER_FARE
     * 名前キー:  METER_FARE
     */
    [FareTypeEnum.METER_FARE]: 'メーター運賃',
    METER_FARE:                             'メーター運賃',
    /**
     * 数値キー: FareTypeEnum.FIXED_FARE
     * 名前キー:  FIXED_FARE
     */
    [FareTypeEnum.FIXED_FARE]: '事前確定',
    FIXED_FARE:                             '事前確定',
    /**
     * 数値キー: FareTypeEnum.FIXED_FARE_RS
     * 名前キー:  FIXED_FARE_RS
     */
    [FareTypeEnum.FIXED_FARE_RS]: '事前確定運賃（RS含む）',
    FIXED_FARE_RS:                             '事前確定運賃（RS含む）',
} as const;

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）) のラベル Union 型
 * @export
 * @typedef FareTypeLabel
 */
export type FareTypeLabel =
  typeof FareTypeLabels[keyof typeof FareTypeLabels];

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）) のラベル取得関数
 * @export
 * @param { FareType } value - 列挙体の値
 * @returns { FareTypeLabel } ラベル文字列
 */
export function getFareTypeLabel(
  value: FareType
): FareTypeLabel {
  return FareTypeLabels[value];
}

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）) のラベル配列を取得する関数
 * @export
 * @param { FareType[] } values - 列挙体の値配列
 * @returns { FareTypeLabel[] } ラベル文字列配列
 */
export function getFareTypeLabels(values: FareType[]): FareTypeLabel[] {
  return values.map((value) => getFareTypeLabel(value));
}

/**
 * 料金種別 (1:メーター運賃, 2:事前確定, 3:事前確定運賃（RS含む）) のラベル配列
 * @export
 */
export const FareTypeLabelList = [
  'メーター運賃','事前確定','事前確定運賃（RS含む）',
] as const;

